import axiosInstance from 'services/common/instance';

const getMenusService = async (): Promise<MenusResponseTypes[]> => {
  const response = await axiosInstance.get('menus');
  return response.data.data;
};

export default getMenusService;
